import AuthLayout from '../layouts/AuthLayout.vue'

export default {
  path: '/',
  name: 'public',
  component: AuthLayout,
  redirect: {
    name: 'public.proforma-invoice.new',
  },
  children: [
    {
      path: '/public/proforma-invoice/new',
      name: 'public.proforma-invoice.new',
      component: () => import('@/views/public-views/ProformaInvoicePublic.vue'),
      meta: {
        title: 'Generate Proforma Invoice',
      },
    },
  ],
}
